export const state = () => ({
  appliedStates: {} // { [mtrlNo]: boolean }
})

export const mutations = {
  SET_APPLIED_STATE (state, { mtrlNo, isApplying }) {
    state.appliedStates = {
      ...state.appliedStates,
      [String(mtrlNo)]: !!isApplying
    }
  },
  CLEAR_APPLIED_STATES (state) {
    state.appliedStates = {}
  }
}

export const getters = {
  // 특정 소재(들)의 신청 상태를 확인. 스토어에 상태가 없으면 defaultValue(API 데이터 등)를 반환.
  isExhibitionApplied: (state, getters, rootState) => (ids, defaultValue = false) => {
    // 비로그인 시 무조건 false (알림신청은 로그인 필요)
    if (!rootState?.session?.member?.mbMngNo) { return false }

    const idArray = Array.isArray(ids) ? ids : [ids]

    // [DRNQ-3083] 1. Cookie 우선 확인 (다른 모듈에서 변경했을 수 있음)
    try {
      if (typeof window !== 'undefined' && window.$nuxt && window.$nuxt.$cookiz) {
        const syncStates = window.$nuxt.$cookiz.get('exh_sync_states')
        if (syncStates && typeof syncStates === 'object') {
          for (const id of idArray) {
            if (!id) { continue }
            if (syncStates[String(id)] !== undefined) {
              return !!syncStates[String(id)]
            }
          }
        }
      }
    } catch (e) {}

    // 2. Vuex 상태 확인
    for (const id of idArray) {
      if (!id) { continue }
      const s = state.appliedStates[String(id)]
      if (s !== undefined) {
        return s
      }
    }
    return !!defaultValue
  }
}
export const actions = {
  // 알림 신청 상태 변경 (여러 ID를 동시에 업데이트하여 페이지 간 동기화 보장)
  toggleExhibition ({ commit }, { mtrlNo, mtrlNo7, exbtNo, isApplying }) {
    const ids = [mtrlNo, mtrlNo7, exbtNo].filter(id => id && String(id).trim() !== '')
    ids.forEach((id) => {
      commit('SET_APPLIED_STATE', { mtrlNo: String(id), isApplying })
    })

    // [DRNQ-3083] MO/FO 간 로컬 상태 동기화를 위해 쿠키에 저장 (가장 확실한 document.cookie 방식)
    try {
      if (typeof document !== 'undefined') {
        let syncStates = {}
        // 기존 쿠키 읽기
        const cookiePair = document.cookie.split('; ').find(row => row.startsWith('exh_sync_states='))
        if (cookiePair) {
          try {
            const val = decodeURIComponent(cookiePair.split('=')[1])
            syncStates = JSON.parse(val)
          } catch (e) { syncStates = {} }
        }

        ids.forEach((id) => {
          syncStates[String(id)] = isApplying
        })

        // 쿠키 굽기 (7일 유지, 도메인 공유)
        const jsonVal = encodeURIComponent(JSON.stringify(syncStates))
        const expires = new Date(Date.now() + 7 * 864e5).toUTCString()
        let cookieStr = `exh_sync_states=${jsonVal}; path=/; expires=${expires}`

        if (location.hostname.includes('daisomall.co.kr')) {
          cookieStr += '; domain=.daisomall.co.kr'
        }

        document.cookie = cookieStr
        console.log('[Cookie Sync] document.cookie updated:', syncStates)
      }
    } catch (e) {
      console.warn('exh_sync_states cookie set error', e)
    }
  },
  // 초기 데이터 싱크가 필요할 경우
  syncAppliedState ({ commit }, { mtrlNo, isApplying }) {
    if (mtrlNo) { commit('SET_APPLIED_STATE', { mtrlNo: String(mtrlNo), isApplying }) }
  }
}
